// src/components/Careers/Benefits/Benefits.js
import React from 'react';
import BenefitCard from './BenefitCard';
import './Benefits.css';

const benefits = [
  {
    title: 'Be Your Best Self',
    description: 'A generous all-in-one wellness benefit. Use it on anything from workout equipment to hobby gear to gadgets to gaming consoles.',
    imageUrl: 'https://sendbird.imgix.net/cms/img_be-your-best-self.jpg?auto=format,compress&crop=faces&w=230'
  },
  {
    title: 'Global Citizenship',
    description: 'As a global company, we encourage exploring each other\'s cultures. We’ll pay for you to learn a new language with our global citizenship benefit.',
    imageUrl: 'https://sendbird.imgix.net/cms/img_global-citizenship.jpg?auto=format,compress&crop=faces&w=230'
  },
  {
    title: 'Generous PTO',
    description: 'In addition to paid holidays, accrued vacation and sick leave, employees get paid volunteer time off, and a good amount of family or paternal leave.',
    imageUrl: 'https://sendbird.imgix.net/cms/img_pto.jpg?auto=format,compress&crop=faces&w=230'
  },
  {
    title: 'Rest & Rejuvenate',
    description: 'Take a non PTO day off to enjoy your birthday or just to relax and refresh yourself.',
    imageUrl: 'https://sendbird.imgix.net/cms/img_rest.jpg?auto=format,compress&crop=faces&w=230'
  }
];

function Benefits() {
  return (
    <section className="benefits-section">
      <div className="benefits-container">
        <h2 className="benefits-title">A few of our benefits</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <BenefitCard key={index} {...benefit} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Benefits;